import React, { useEffect } from 'react';
import Wrapper from '../../components/Wrapper';
import FieldOfficerOfPartnerTable from '../../components/tables/FieldOfficerOfPartnerTable';

import { useParams } from 'react-router-dom';
import { fetchFieldOfficersByAdminId } from '../../store/features/fieldOfficerByPartnerSlice';
import { useDispatch, useSelector } from 'react-redux';

const FieldOfficerOFPartner = () => {
  const dispatch = useDispatch();
  const { admin_id } = useParams();
  const { fieldOfficers, status } = useSelector(
    (state) => state.fieldOfficerByPartner
  );

  useEffect(() => {
    dispatch(fetchFieldOfficersByAdminId({ admin_id }));
  }, [admin_id, dispatch]);

  return (
    <Wrapper>
      {status === 'loading' ? (
        <div>Loading...</div>
      ) : (
        <FieldOfficerOfPartnerTable fieldOfficers={fieldOfficers} />
      )}
    </Wrapper>
  );
};

export default FieldOfficerOFPartner;